module.exports = __webpack_public_path__ + "static/media/logo192x192.8fe2c6e8.png";